import { useQuery } from "@tanstack/react-query";
import { SystemIndexSetsTypes } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = [];
const fetchAllIndexSetIds = async (streams) => SystemIndexSetsTypes.indexSetsWithFieldTypeChangeSupport((streams == null ? void 0 : streams.length) ? streams : void 0).then((elements) => {
  const list = elements.map((element) => ({
    id: element.index_set_id,
    type: element.type
  }));
  return list;
});
const useAllIndexSetIds = (streams) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["allIndexSetIds", ...streams],
    queryFn: () => defaultOnError(
      fetchAllIndexSetIds(streams),
      i18n.t("change_field_type.load_index_sets_failed", { ns: "search" }),
      i18n.t("change_field_type.could_not_load_index_sets", { ns: "search" })
    )
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useAllIndexSetIds;
